module.exports = __webpack_public_path__ + "static/media/0.c7876a20.jpg";